
<gw-findings-table [findingsStatus]="'in_progress'"></gw-findings-table>